// #POW-21
import Config from '../../Config';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton, CircularProgress, Box, Typography, Alert } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import useCustomFetch from '../../hooks/useCustomFetch';
import { GridValidRowModel } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next"; // #POW-29
import { data } from 'react-router-dom';

function formattedDate(date: string | Date) { 
    return new Intl.DateTimeFormat('it-IT', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    }).format(new Date(date));
};

export default function DialogCheckInTransaction(
    { open, onClose, selectedRows, refreshDataGrid }: { open: boolean; onClose: () => void; selectedRows?: GridValidRowModel[]; refreshDataGrid: (value: boolean) => void  }
){
    const { t } = useTranslation();  // #POW-29
    const customFetch = useCustomFetch()
    const [isLoading, setIsLoading] = useState(false)

    const [isError, setIsError] = useState(false)
    const [isSuccess, setIsSuccess] = useState(false)
    const [dataSent, setDataSent] = useState(false)

    const [errorList, setErrorList] = useState("") // #POW-52
    const [errorListCount, setErrorListCount] = useState(0) // #POW-52

    const handleClose = () => { // #POW-52
        
        if(dataSent)
            refreshDataGrid(true)

        onClose();
        setTimeout(
            function () {  
                setIsError(false);
                setIsSuccess(false);  
                setErrorList("");
                setErrorListCount(0);
                setDataSent(false)
            }, 
            500)
       
      };

    //  Mark transactions as checked-in
    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        setIsLoading(true)
        setIsError(false)
        setIsSuccess(false)
        event.preventDefault();
        const url = `${Config.serverUrl}/api/logistic/transactions/check-in`;
        const response = await customFetch(url, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ transactions: selectedRows?.map((t) => t.id )}),
        });
      
        if (response.ok) {
            const resonseData = await response.json();
            
            if(resonseData.status == "success")
            {
                setIsSuccess(true)
            }
            else
            {
                setIsError(true);
                setErrorListCount(resonseData.list.length)
                setErrorList(resonseData.list.join("\n"))
            }

            setDataSent(true)
                  
        }
        else{
            setIsError(true)
            setErrorListCount(selectedRows ? selectedRows.length: 0)
            const errList = selectedRows? selectedRows.map((t) => t.id ) : [];
            setErrorList(errList.join("\n"))
        }
        
        setIsLoading(false)
        //onClose();
    };

     useEffect(() => { 
        if(open) {
            setDataSent(false)
            setIsLoading(false)
            setIsError(false)
            setIsSuccess(false)
        }
      }, [open]);

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth='md'>

            {isLoading && (
                <>
                <DialogTitle fontWeight={'bold'}>{t("incomingTransactions.dialog.loading")}</DialogTitle>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                    <CircularProgress />
                </div>
                </>
            )}

            {!isLoading && (
                <form onSubmit={handleSubmit}>
                    <DialogTitle fontWeight={'bold'}>{t("incomingTransactions.dialog.title")}</DialogTitle>
                    <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}
                    >
                    <CloseIcon />
                    </IconButton>
                    <DialogContent dividers>
                        {selectedRows && selectedRows?.length >1 && <Typography sx={{ mb: 1 }} >
                            {t('incomingTransactions.dialog.text', { value: selectedRows?.length })}
                        </Typography>} {/* #POW-52 */}
                        {selectedRows && selectedRows?.length == 1 && <Typography sx={{ mb: 1 }} >
                            {t('incomingTransactions.dialog.textSingle')}
                        </Typography>} {/* #POW-52 */}
                        <Box sx={{
                            mb: 2,
                            display: "flex",
                            flexDirection: "column",
                            maxHeight: 300,
                            overflow: "hidden",
                            overflowY: "scroll",
                            border: "1px solid #cccccc"
                        }}>
                            {selectedRows && selectedRows.map((row:GridValidRowModel, index: number) => 
                                <p
                                    key={index}
                                    style={{
                                    backgroundColor: index % 2 === 0 ? "#f0f0f0" : "#ffffff",
                                    margin: 0,
                                    padding: "8px",
                                    }}
                                >
                                    <b>{row.id}</b> - {row.device_name} ({formattedDate(row.date)})
                                </p> 
                            )}
                        </Box>
                        {isSuccess && <Alert severity="success" variant="outlined">{t("incomingTransactions.dialog.success")}</Alert>}
                        {isError && errorListCount==1 && 
                            <Alert severity="error" variant="outlined" sx={{maxHeight:"200px", width:"100%"}}>
                                {t("incomingTransactions.dialog.errorSingle")}<br/>
                            </Alert>} {/* #POW-52 */}
                        {isError && errorListCount>1 && 
                         <Alert severity="error" variant="outlined">
                            {t("incomingTransactions.dialog.error", { value: errorListCount })}
                            <pre>{errorList}</pre>
                        </Alert>} {/* #POW-52 */}
                    </DialogContent>
                    <DialogActions>
                    {!isSuccess && 
                        <>
                            <Button autoFocus onClick={handleClose} color="primary" variant="outlined">{t("transactions.dialog.cancel")}</Button>
                            <Button type="submit" color="primary" variant="contained">{t("incomingTransactions.dialog.save")}</Button>
                        </>
                    } {/* #POW-52 */}
                    {isSuccess && <Button autoFocus onClick={handleClose} color="primary" variant="contained">{t("transactions.dialog.close")}</Button>} {/* #POW-52 */}

                    </DialogActions>
                </form>
            )}

        </Dialog>
    )
}